import styled from '@emotion/styled';
import VerticalMoveIcon from 'src/assets/icons/VerticalMoveIcon';

export const LabelHeader = styled('div', { label: 'LabelHeader' })`
    padding-bottom: 5px;
`;

export const SportList = styled('ul', { label: 'SportList' })`
    list-style-type: none;
    margin: 0;
    padding: 0;
`;

export const SportListItem = styled('li', { label: 'SportListItem' })<{ isDragged: boolean }>`
    background-color: #eee;
    border: 1px solid rgba(0, 0, 0, .2);
    color: #333;
    font-size: 12px;
    padding: 8px 10px;
    width: 100%;
    z-index: ${props => props.isDragged ? '10001' : 'inherit'};

    :hover,:focus {
        background: #f3f3f3;
    }
`;

// SportItemGeneral
export const ItemButton = styled('span', { label: 'ItemButton' })<{ isDragged: boolean }>`
    cursor: ${props => props.isDragged ? 'grabbing' : 'grab'};
    display:flex;
`;

export const ItemWrapper = styled('div', { label: 'ItemWrapper' })`
    display: flex;
    justify-content: space-between;
`;
export const VerticalMoveIconWrapper = styled(VerticalMoveIcon, { label: 'VerticalMoveIconWrapper' })`
    position: absolute;
    right: 10px;
    top: 13px;
`;
